<footer class="app-footer py-3 px-2">
  <div class="container-fluid">
    <div class="row align-items-center gy-2">

      <!-- Left -->
      <div class="col-md-6 text-center text-md-start">
        <!-- <span class="footer-text">
          © {{ currentYear }} <strong class="fw-bold text-black">சமயபுரம் மாரியம்மன் கோவில்</strong>. All rights reserved.
        </span> -->
      </div>

      <!-- Right -->
      <div class="col-md-6 text-center text-md-end">
        <span>Designed & Developed By </span><a href="https://cktechsoln.in" target="_blank" class="footer-link text-decoration-none">CKTech Solution</a>
      </div>

    </div>
  </div>
</footer>

